import { IDemandDocumentParser } from '@api/settings/model/types.ts';
import React from 'react';

interface IDemandDocumentParserContextProps {
  demandDocumentParser: IDemandDocumentParser | null;
  setDemandDocumentParser: React.Dispatch<
    React.SetStateAction<IDemandDocumentParser | null>
  >;
  updateDemandDocumentParser: (data: any | null) => void;
}

const DemandDocumentParserContext =
  React.createContext<IDemandDocumentParserContextProps>(
    {} as IDemandDocumentParserContextProps
  );

export default DemandDocumentParserContext;
